<template>
	<span class="warning--text">Missing {{ param.type }}</span>
</template>

<script>
export default {
	props: [ 'param' ]
}
</script>



// WEBPACK FOOTER //
// src/components/fields/missing.vue